// src/admin/ProtectedRoute.tsx
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';

interface ProtectedRouteProps {
  requiredRole?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ requiredRole }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      const token = authService.getToken();
      const role = authService.getRole();

      if (!token) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // Vérifier si le token est expiré
      if (authService.isTokenExpired(token)) {
        authService.logout();
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // Vérifier le rôle si requis
      if (requiredRole && role !== requiredRole) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      setIsAuthenticated(true);
      setIsLoading(false);
    };

    checkAuth();

    // Vérifier toutes les 60 secondes
    const interval = setInterval(checkAuth, 60000);

    return () => clearInterval(interval);
  }, [requiredRole]);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login-admin" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;